import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import Chart from 'pared/pages/CorporateGuest/BreakdownTable'

import { FROM_EXPO } from '../../constants'
import { IMessage } from '../../type'

const VerticalSpacer = styled.div`
  width: 100%;
  height: 50px;
`

export default function handleGuestKpiRankings(responseData: any) {
  if (responseData?.guestKpiRankings) {
    const messageId = uuidv4()
    const results = responseData.guestKpiRankings
    const uiComponents: React.ReactNode[] = []

    if (results.guest.locations) {
      // Rank stores
      const dlgData = results.guest.locationGroups
      uiComponents.push(
        <div>
          {uiComponents.length > 0 ? <VerticalSpacer /> : null}
          <div>{dlgData.locationGroupNames.join(', ')}</div>
          <Chart
            isBreakdownByDirectors={false}
            startDate={dlgData?.startDate}
            endDate={dlgData?.endDate}
            locationGroupId={dlgData?.locationGroupIds[0]}
            locationGroupIds={[]}
            breakdownType={null}
          />
        </div>,
      )
    } else if (results.guest.locationGroups) {
      // Rank directors
      const dlgData = results.guest.locationGroups
      uiComponents.push(
        <div>
          {uiComponents.length > 0 ? <VerticalSpacer /> : null}
          <div>{dlgData.locationGroupNames.join(', ')}</div>
          <Chart
            isBreakdownByDirectors={true}
            startDate={dlgData?.startDate}
            endDate={dlgData?.endDate}
            locationGroupId={dlgData?.locationGroupIds[0]}
            locationGroupIds={dlgData?.locationGroupIds}
            breakdownType={null}
          />
        </div>,
      )
    }

    if (uiComponents.length > 0) {
      const answerMessage: IMessage = {
        id: messageId,
        from: FROM_EXPO,
        content: <div>{uiComponents}</div>,
      }

      return answerMessage
    }
  }

  return null
}
